import TransactionProofs from './TransactionProofs';

export default TransactionProofs;